import type { AxiosResponse } from 'axios'
import type { Profile, PaginationParams, Pagination } from 'types'

export enum ActionType {
  GET_USERS = 'GET_USERS',
  SET_USERS = 'SET_USERS',
}

export type GetUsersResponseData = {
  data: Profile[]
} & Pagination

export type GetUsersPayload = PaginationParams

export type GetUsersResponse = AxiosResponse<GetUsersResponseData>
